// Recovered compiled webpack factory 38358. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { k: () => n });
  let { schedule: n } = (0, i(44300).I)(queueMicrotask, !1);
}
